<div class="description">
    <mat-icon class="description-icon" [style]="getIconStyle(iconType)">{{
        getIcon(iconType)
      }}</mat-icon>
    <label class="description-title">{{ title }}</label>
</div>
<div class="desc-content" [innerHTML]="renderedContent"></div>